const api = {
    baseURL: 'http://202.179.6.51:5800',
    imgURL: 'http://8.araa.mn/img',
};

export default api;